/**
 * Custom Validators for Foundation Abide
 */
'use strict';

// Utilities
import debug from "debug";

const MODULE_NAME = 'common/vendor/extensions/abide-validators';
const log = debug(MODULE_NAME);


// Foundation
import '@vendor/foundation/js/foundation.core';
import '@vendor/foundation/js/foundation.abide';

// Constants
const ABIDE_SELECTOR = '[data-abide]';
const CHECKBOX_SELECTOR = '[type="checkbox"]';
const CHECKBOX_GROUP_SELECTOR = '.checkbox-group';

/**
 * Minimum required validator for checkbox groups.
 * Set `minRequired` on formFieldOptionList model to activate.
 * If upgrading Foundation to 6.3+, check if this PR has been accepted
 * because then this function will be redundant: https://github.com/zurb/foundation-sites/pull/8542
 *
 * @param $el
 * @param required
 * @param parent
 */
Foundation.Abide.defaults.validators['minRequired'] = ($el, required) => {
	let $group = $el.closest(CHECKBOX_GROUP_SELECTOR);

	let groupMinRequired = $group.data('min-required');
	let minRequired = (groupMinRequired && groupMinRequired !== true) ? groupMinRequired : 1;

	return $group.find(':checked').length >= minRequired;
};

// Export
export default function run () {
	log('Running...');

	/**
	 * Handle Checkbox Groups (because Foundation doesn't <= 6.2.x
	 */
	let $groupedCheckboxes = $(CHECKBOX_GROUP_SELECTOR).find(CHECKBOX_SELECTOR);

	if ($groupedCheckboxes.length) {
		log('$groupedCheckboxes:', $groupedCheckboxes);

		// When a checkbox in a group becomes valid
		$groupedCheckboxes.on('valid.zf.abide', function () {
			let $form = $(this).closest(ABIDE_SELECTOR);
			$(this).closest(CHECKBOX_GROUP_SELECTOR).find(CHECKBOX_SELECTOR).each(function(){
				$form.foundation('removeErrorClasses', $(this));
			});
		});

		// When a checkbox in a group is invalid
		$groupedCheckboxes.on('invalid.zf.abide', function () {
			let $form = $(this).closest(ABIDE_SELECTOR);
			$(this).closest(CHECKBOX_GROUP_SELECTOR).find(CHECKBOX_SELECTOR).each(function () {
				$form.foundation('addErrorClasses', $(this));
			});
		});
	} else {
		log('No $groupedCheckboxes found.');
	}

}


